// Feriados NACIONAIS (federais) do Brasil — tabela estática para a contagem de
// dias úteis dos prazos do rito (ver prazos.ts). Decisão 2026-07-20: escopo
// APENAS nacional/federal (municipal/estadual fora — o prazo do canal é
// legal/empresa-wide e a lotação varia por pessoa; o mecanismo é por-data,
// então estadual/municipal pode entrar neste mesmo Set depois, se decidido).
//
// Fonte: feriados civis/religiosos nacionais em lei federal (Lei 662/1949,
// 6.802/1980, 10.607/2002 e 14.759/2024 — Consciência Negra nacional). Os
// "pontos facultativos" (Carnaval, Quarta-feira de Cinzas, Corpus Christi) NÃO
// são feriados nacionais por lei e ficam FORA desta tabela por ora — como os
// prazos são SLA SOFT (só alerta visual, não bloqueiam transição), a omissão
// não trava nada; se a empresa adotá-los como não-úteis, basta acrescentá-los.
//
// Feriados móveis (Sexta-feira Santa) têm data calculada por ano e entram como
// literais explícitos — tabela estática, sem cálculo em runtime. Follow-up
// anual: estender o range conforme os anos avançam.
//
// Datas em 'YYYY-MM-DD' UTC (chave casada por `diaUtcKey` em prazos.ts).

import type { Feriados } from './prazos.js';

export const FERIADOS_NACIONAIS: Feriados = new Set<string>([
  // 2026
  '2026-01-01', // Confraternização Universal
  '2026-04-03', // Sexta-feira Santa (móvel)
  '2026-04-21', // Tiradentes
  '2026-05-01', // Dia do Trabalho
  '2026-09-07', // Independência
  '2026-10-12', // Nossa Senhora Aparecida
  '2026-11-02', // Finados
  '2026-11-15', // Proclamação da República
  '2026-11-20', // Consciência Negra (nacional — Lei 14.759/2024)
  '2026-12-25', // Natal
  // 2027
  '2027-01-01', // Confraternização Universal
  '2027-03-26', // Sexta-feira Santa (móvel)
  '2027-04-21', // Tiradentes
  '2027-05-01', // Dia do Trabalho
  '2027-09-07', // Independência
  '2027-10-12', // Nossa Senhora Aparecida
  '2027-11-02', // Finados
  '2027-11-15', // Proclamação da República
  '2027-11-20', // Consciência Negra
  '2027-12-25', // Natal
]);
